export const getLocalStorageJSON = (key, fallback = null) => {
  const value = localStorage.getItem(key);

  if (!value || value === "undefined" || value === "null") {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    console.error(`Invalid JSON in localStorage for "${key}"`, error);

    localStorage.removeItem(key);

    return fallback;
  }
};
